import { createContext, useContext, useState, useEffect,  } from 'react';

// Create ScoreContext
const ScoreContext = createContext();

// Create a Provider component
export function ScoreProvider({ day, children }) {
	const [score, setScore] = useState([0,0,0,0,0,0,0,0,0,0]); // score for each grid cell
	const [cs, setCS] = useState(0);
	const [gridCount, setGridCount] = useState(0); // number of solved cells
	const [chosenServents, setChosenServents] = useState([]); // for dupe servent
    const [optionStateFlags, setOptionStateFlags] = useState([0, -1, -1, -1, -1, -1, -1, -1, -1, -1, 3]); // for keeping track of when game is ending
	const [gameEnded, setGameEnded] = useState(false);
	const [optionsState, setOptionsState] = useState({});
	const [hintVisibleToggle, setHintVisibleToggle] = useState(false);

	useEffect( () => {
		const savedDay = localStorage.getItem(`day${day}`);
		if (!savedDay) return;
		let dayObject = JSON.parse(savedDay);
		const savedCS= dayObject['cs'];
		const savedScore = dayObject['score'];
		// console.log(savedScore, typeof(savedScore));
		if (dayObject['ended']) updateStateEndGame();
		if (savedCS) setCS(savedCS);
		setOptionStateFlags(optionStateFlags);
		setScore(savedScore);
		// console.log('optionstate', JSON.stringify(optionsState), 'flags', optionStateFlags, 'score', score, 'chosen', JSON.stringify(chosenServents), 'grid', gridCount);
	}, []);

	const AddOptionState = (optionId, serventId, percent, shouldIncCount, shouldSave) => {
		// console.log(percent);
		const option = {'id': serventId, 'percent': percent};
		const tempState = optionsState;
		tempState[optionId] = option;
		setOptionsState(tempState);
		updateOptionStateFlags(optionId, 0);
		if (serventId > 0) {
			addChosen(serventId);
		}
		if (shouldIncCount) {
			incrementGridCount(1);
		}
		let s = score;
		if (percent >= 0) {
			s = addScore(optionId, serventId, percent);
		} else if (percent === -100) {
			s = addScore(optionId,serventId, 0.01);
		}
		if (shouldSave) saveOptionToLocalStorage(optionId, option, s);
	}
 

	// assumes state to be removed exists
	const RemoveOptionState = (optionId, shouldDecCount) => {
		const tempState = optionsState;
		const tempScore = score;
		tempScore[optionId] = 0;
		removeChosen(tempState[optionId]['id']);
		if (shouldDecCount) incrementGridCount(-1);
		// addScore(optionId, -1, 1); // set score 0 for optionId
		// updateUseCSstate(optionId, true);
		setCS(prevCS => prevCS - 1);
		delete tempState[optionId];
		setOptionsState(tempState);
		setScore(tempScore);
		removeOptionFromLocalStorage(optionId, tempScore);

	}

	const getOptionState = (optionId) => {
		// console.log(optionsState[optionId]['percent']);
		return optionsState[optionId];
	}

	const getOptionIds = () => {
		return Object.values(optionsState).map(op => {
			return op['id']; 
		});
	}

	// Function to update the score
	const addScore = (optionId, serventId, percent) => {

		let s = 100 - 100*percent;
		if (chosenServents.includes(serventId)) {
			s /= 2;
		}
		let updatedScore = [
			...score.slice(0, optionId), s, ...score.slice(optionId+1)
		];
		setScore(updatedScore);
		return updatedScore;
	};

	const incrementGridCount = (newGridCount) => {
	    setGridCount((prevGridCount) => prevGridCount + newGridCount);
	};

	const addChosen = (newID) => {
        setChosenServents([...chosenServents, newID]);
	};

    const removeChosen = (chosenID) => {
        const index = chosenServents.lastIndexOf(chosenID);
        const newItems = [...chosenServents];
        newItems.splice(index, 1);
        setChosenServents(newItems);
    }

	const updateOptionStateFlags = (optionID, flag) => {
		const state = optionStateFlags;
		state[optionID] = flag;
		setOptionStateFlags(optionStateFlags);
	}

	const updateHintState = (optionID, hintIds) => {
		const state = optionsState;
		// console.log("state", state);
		if (!state[optionID]) {
			state[optionID] = {};
		}
		if (!state[optionID]['hint']) {
			state[optionID]['hint'] = hintIds;
		}
		// state['test'] = 'poooooooooooooo';
		let localDayData = localStorage.getItem(`day${day}`);
        if (!localDayData) return;
		// if (state['cs']) {
		// 	state['cs'] -= 1;
		// }
		localDayData = JSON.parse(localDayData);
		localDayData[optionID] = state[optionID];
		// console.log(localDayData);
		localDayData['cs']--;
		setCS(prevCS => prevCS - 1);
		// updateUseCSstate(optionID, false);
		// console.log(score, s);
		localStorage.setItem(`day${day}`, JSON.stringify(localDayData));
		setTimeout(() => {
			console.log(optionsState);
		}, 1000);

	}

	const updateStateEndGame = () => {
		const savedOptions = Object.keys(optionsState);
		for (let i = 1; i <= 9; i++) {
			let key = i.toString();
			if (!savedOptions.includes(key)) {
				AddOptionState(key, -1, -1, false,true);
			}
		}
		const savedDay = localStorage.getItem(`day${day}`);
		if (savedDay) {
			let dayObject = JSON.parse(savedDay);
			dayObject['ended'] = true;
			localStorage.setItem(`day${day}`, JSON.stringify(dayObject));
		}
		const state = optionStateFlags;
		setOptionStateFlags([0,0,0,0,0,0,0,0,0,0, state[10]]);
		setGameEnded(true);
	}

	const saveOptionToLocalStorage = (optionId, optionData, s) => {
		let localDayData = localStorage.getItem(`day${day}`);
        if (!localDayData) return;
		localDayData = JSON.parse(localDayData);
		localDayData["score"] = s;
		if (!localDayData[optionId]) localDayData[optionId] = {}
		localDayData[optionId]['id'] = optionData['id'];
		localDayData[optionId]['percent'] = optionData['percent'];
		// console.log(score, s);
		localStorage.setItem(`day${day}`, JSON.stringify(localDayData));
	}

	const removeOptionFromLocalStorage = (optionId, s) => {
		let localDayData = localStorage.getItem(`day${day}`);
        if (!localDayData) return;
		localDayData = JSON.parse(localDayData);
		localDayData["score"] = s;
		localDayData["cs"]--;
		delete localDayData[optionId]['id'];
		delete localDayData[optionId]['percent'];
		localStorage.setItem(`day${day}`, JSON.stringify(localDayData));
	}

	return (
	<ScoreContext.Provider value={{ day, score,  gridCount,  hintVisibleToggle, gameEnded, cs, getOptionState, getOptionIds, AddOptionState, RemoveOptionState, updateStateEndGame, updateHintState, setHintVisibleToggle  }}>
		{children}
	</ScoreContext.Provider>
	);
}

// Custom hook to use the ScoreContext
export function useScore() {
	const context = useContext(ScoreContext);
	if (!context) {
	throw new Error('useScore must be used within a ScoreProvider');
	}
	return context;
}
